<template>
    <footer class="ms-footer" v-if="ll">
        <ul class="ms-footer__nav">
            <li class="ms-footer__nav-item">
                <router-link :to="'/'" replace data-vl="10146">{{ll.i10146||'Home'}}</router-link>
            </li>
            <li class="ms-footer__nav-item">
                <router-link :to="'/#faq'" replace data-vl="10147">{{ll.i10147||'FAQ'}}</router-link>
            </li>
            <li class="ms-footer__nav-item">
                <router-link :to="'/#contact'" replace data-vl="10148">{{ll.i10148||'Contact us'}}</router-link>
            </li>
            <li class="ms-footer__nav-item">
                <router-link :to="'/privacy-policy'" replace data-vl="10205">{{ll.i10205||'Privacy Policy'}}</router-link>
            </li>
            <li class="ms-footer__nav-item">
                <router-link :to="'/terms-of-service'" replace data-vl="10236">{{ll.i10236||'Terms of Service'}}</router-link>
            </li>
        </ul>
    </footer>
</template>

<script>
    export default {
        name: "AppFooter",
        computed:{
            ll(){
                return this.$root.ll;
            }
        },
    }
</script>

<style scoped>

</style>